// PanchangLayout.jsx
// Parent layout component — handles tab navigation between Panchang, Horoscope, Subscriptions

import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AutoStoriesOutlinedIcon   from "@mui/icons-material/AutoStoriesOutlined";
import PeopleAltOutlinedIcon     from "@mui/icons-material/PeopleAltOutlined";

import CustomTabs        from "../../common/custom-tabs";        // reusable tab component
import PanchangUI        from "./UploadData";        // existing page
import HoroscopePage     from "./HoroscopePage";
import SubscriptionsPage from "./SubscriptionsPage";
import { ColorsConstants } from "../../cssUtils/constants";
import typography from "../../cssUtils/typography";

// ── Tab definitions ─────────────────────────────────────────────────────────
// Following the pattern from UsageCharges.jsx - each tab has a label and numeric value
const TABS = [
  {
    value: 0,  // Using numeric index as value
    label: (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} />
        Panchang
      </Box>
    ),
  },
  {
    value: 1,  // Numeric value
    label: (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <AutoStoriesOutlinedIcon sx={{ fontSize: 16 }} />
        Horoscope
      </Box>
    ),
  },
  {
    value: 2,  // Numeric value
    label: (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <PeopleAltOutlinedIcon sx={{ fontSize: 16 }} />
        Subscriptions
      </Box>
    ),
  },
];

// ── Page map ────────────────────────────────────────────────────────────────
// Map numeric indices to components
const PAGE_MAP = {
  0: PanchangUI,
  1: HoroscopePage,
  2: SubscriptionsPage,
};

// ── Component ───────────────────────────────────────────────────────────────
const PanchangLayout = () => {
  // Use numeric index for active tab (just like UsageCharges.jsx uses numbers)
  const [activeTab, setActiveTab] = useState(0);  // Start with Panchang (index 0)

  const ActivePage = PAGE_MAP[activeTab];

  return (
    <Box sx={{ minHeight: "100vh", background: "#F4F7FC" }}>

      {/* ── Top app bar ── */}
      <Box
        sx={{
          background: "#fff",
          borderBottom: "1px solid #E5E7EB",
          px: 4,
          py: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          zIndex: 200,
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        }}
      >
        {/* Tab navigation — sticky in the header */}
        <CustomTabs
          value={activeTab}  // Directly pass the numeric index
          onChange={(_, newIndex) => setActiveTab(newIndex)}  // newIndex is the numeric value
          tabs={TABS}  // TABS now have numeric values
          activeBgColor={ColorsConstants.primaryBackgroundColor}
          inactiveBgColor="#F3F5F7"
          activeTextColor="#ffffff"
          inactiveTextColor="#6B7280"
          sx={{
            minHeight: 44,
            p: "3px",
            borderRadius: "10px",
          }}
          tabSx={{
            px: 3,
            minWidth: 120,
            minHeight: 38,
            borderRadius: "8px",
          }}
        />
      </Box>

      {/* ── Page content ── */}
      <Box
        key={activeTab}
        sx={{
          animation: "tabFadeIn 0.18s ease",
          "@keyframes tabFadeIn": {
            from: { opacity: 0, transform: "translateY(6px)" },
            to:   { opacity: 1, transform: "translateY(0)"   },
          },
        }}
      >
        <ActivePage />
      </Box>

    </Box>
  );
};

export default PanchangLayout;